<template>
  <div v-if="showModal" class="dialog-modal">
    <div class="modal-overlay"></div>
    <div class="modal-container" :style="modalStyle">
      <div class="modal-container-header">
        <span>{{ title }}</span>
        <img
          class="dialog-close"
          src="@/assets/images/close.png"
          width="14"
          height="14"
          @click="closeDialog"
        />
      </div>
      <div class="modal-container-content">
        <div class="channel-right">
          <div v-for="(item, index) in channelList" class="item" @click="handelSelectChannel(item)">
            <el-button style="padding: 0" type="text"
              >【{{ index + 1 }}】{{ item.channelName }}</el-button
            >
          </div>
        </div>
        <div style="margin: 20px 0 10px 0; color: #888888">
          <span>{{ $t("channelDialog.tip") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getChannelAll } from "@/constants/channel";

export default {
  name: "ChannelDialog",
  components: {},
  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "弹窗",
    },
  },
  data() {
    return {
      channelList: [],
      channelChild: [],
    };
  },
  computed: {
    modalStyle() {
      if (this.showModal) {
        return {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 99,
        };
      } else {
        return {
          display: "none",
        };
      }
    },
  },
  mounted() {
    this.channelList = getChannelAll();
  },
  methods: {
    handelSelectChannel(item) {
      this.$emit("selectChannel", item);
    },
    // x关闭符号
    closeDialog() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style scoped lang="scss">
.dialog-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;

  .modal-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
  }

  .modal-container {
    position: relative;
    max-width: 90%;
    margin: auto;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);

    .modal-container-header {
      padding: 15px;
      color: #000000;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .dialog-close {
        cursor: pointer;
      }
    }

    .modal-container-content {
      background-color: #f7f7f9;
      padding: 10px 30px;
      border-radius: 10px;
      .channel-right {
        display: grid;
        column-gap: 24px;
        box-sizing: border-box;
        grid-template-columns: repeat(3, 1fr);

        .item {
          border-radius: 8px;
          cursor: pointer;
          margin: 10px 0;
        }
      }
    }
  }
}

.channel-div {
}
</style>
